export const notoSansJpFontVariable = "--speria-fonts-Noto-Sans-JP";
